import React, { useState, useEffect, useContext } from "react";
import MyContext from "../../../../context/MyContext";
import swal from "sweetalert";
import TickerContext from "../../../../context/ticker";
import ProjectContext from "../../../../context/ProjectContext";

const Video = (props) => {
  const {
    timelineZoomVal,
    setLayersData,
    LayersData,
    calculateTimeByWidth,
    clone,
    setRedoLayer,
    UndoLayer,
    setUndoLayer,
    ChangeCount,
    setChangeCount,
    calculateWidthByDuration,
    onePxEquivalent,
    EditorZoom,
    seteditableObject,
  } = useContext(MyContext);
  const { TickerPosition } = useContext(TickerContext);

  const { slides, setslides } = useContext(ProjectContext);
  const [Loader, setLoader] = useState(true);
  const [divShow, setdivShow] = useState(false);
  const [delayHandler, setDelayHandler] = useState(null);
  const [isShown, setIsShown] = useState(true);

  var time = props.duration;
  var minutes = Math.floor(time / 60);
  var seconds = time - minutes * 60;

  var width = props.VideoWidth;
  var height = props.VideoHeight;
  var requireHeight = (163 / width) * height;

  const handleMouseEnter = (event) => {
    setDelayHandler(
      setTimeout(() => {
        setdivShow(true);
      }, 750)
    );
  };

  const handleMouseLeave = () => {
    setdivShow(false);
    clearTimeout(delayHandler);
  };

  function getRandomArbitrary(min, max) {
    return parseInt(Math.random() * (max - min) + min);
  }

  function makeid(length) {
    var result = "";
    var characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }

  const storeVideoUrl = () => {
    var ratio = (300 / width) * height;

    var topIndex = 0;
    //let TickPos;
    var typelength = 1;
    var checkKey = 0;
    var canvasHeight =
      document.getElementsByClassName("EditorTrackInner")[0].offsetHeight;
    var CanvasWidth =
      document.getElementsByClassName("EditorTrackInner")[0].offsetWidth;

    let _widthPercentage = 300 / CanvasWidth;
    let _heightPercentage = ratio / canvasHeight;
    let _width = CanvasWidth * _widthPercentage;
    let _height = canvasHeight * _heightPercentage;

    var top = getRandomArbitrary(0, canvasHeight - _height);
    var left = getRandomArbitrary(0, CanvasWidth - _width);

    let stack = [...UndoLayer];
    let PrevArray = clone(LayersData);

    if (stack.length < 10) {
      stack.push(PrevArray);
      setUndoLayer(stack);
      setRedoLayer([]);
    } else {
      stack.shift();
      stack.push(PrevArray);
      setUndoLayer(stack);
      setRedoLayer([]);
    }

    if (LayersData.length > 0) {
      topIndex = LayersData[LayersData.length - 1].layerIndex;
      topIndex = topIndex + 1;
    }

    var checkVideo = false;
    for (var i = 0; i < LayersData.length; i++) {
      if (LayersData[i].type == "Video" && LayersData.IsVideoSwap == false) {
        swal("This Slide already Contain a video");
        checkVideo = true;
        return;
      }

      if (LayersData[i].type == "Video" && LayersData[i].IsVideoSwap == true) {
        // checkVideo = false
        LayersData[i].url = props.VideoUrl;
        return;
      }

      if (LayersData[i].Editable === true) {
        LayersData[i].Editable = false;
      }
      LayersData[i].toolbar = false;
      if (LayersData[i].type === "Video") {
        typelength = typelength + 1;
      }
      if (LayersData[i].key >= checkKey) {
        checkKey = LayersData[i].key;
      }
    }

    if (!checkVideo) {
      let currentTime = calculateTimeByWidth(TickerPosition);

      let calc = (props.duration * 1000) / onePxEquivalent;
      let totalTime = calculateTimeByWidth(calc);
      let VideoTime = calculateTimeByWidth(calc + TickerPosition);

      let newEntryLayerData = {
        Added: true,
        key: checkKey + 1,
        AnimationId: makeid(8),
        type: "Video",
        bgColor: "#554bf5",
        Name: `Video-${typelength}`,
        layerIndex: topIndex,
        index: null,
        EditorZoom: EditorZoom,
        TimelineZoom: timelineZoomVal,
        duration: totalTime,
        startTime: currentTime,
        endTime: VideoTime,
        volume: 1,
        visible: true,
        OutEffect: "none",
        InEffect: "none",
        audio_node: null,
        typeIcon: "movie",
        startTransitionWidth: 0,
        startTransitionLeft: 0,
        endTransitionWidth: 0,
        endTransitionLeft: 0,
        url: props.VideoUrl,
        ImageSrc: props.url,
        x: left,
        y: top,
        lock: false,
        width: _width,
        height: _height,
        toolbar: false,
        FurtherSetting: false,
        flip: "scaleX(1)",
        opacity: 1,
        originalOpacity: 1,
        layerlock: false,
        opc: 1, //its use for the eye on the timeline wrapper for lock
        hidden: false,
        Editable: true,
        startPositionOnTimeline: TickerPosition,
        player: false,
        rotateAngle: 0,
        InMultiDrag: false,
        showDiv: true,
      };
      newEntryLayerData.widthOnTimeline = calculateWidthByDuration(
        newEntryLayerData.duration
      );
      newEntryLayerData.VideoActualLength = calculateWidthByDuration(
        newEntryLayerData.duration
      );
      newEntryLayerData.VideoActualWidth = VideoTime;
      newEntryLayerData.VideoActualLength_withTMZoom = calculateWidthByDuration(
        newEntryLayerData.duration
      );
      newEntryLayerData.endTransitionLeft =
        newEntryLayerData.widthOnTimeline -
        newEntryLayerData.endTransitionWidth;
      setLayersData(LayersData.concat(newEntryLayerData));
      seteditableObject({
        showPanel: true,
        editableItem: newEntryLayerData,
      });
      let change = false;
      // debugger
      // const array = Array.from(slides)
      // for(let i = 0; i < array.length; i++)
      // {
      //     if(array[i].IsActive)
      //     {
      //         array[i].LayerData.push(newEntryLayerData)
      //         change = true;
      //     }
      // }

      // if(change)
      // {
      //     setTimeout(() => {
      //         setslides(array)
      //     }, 7000);

      // }
      setChangeCount(ChangeCount + 1);
    }
  };

  useEffect(() => {
    if (time < 10) {
      setIsShown("milisecond");
    } else if (time >= 10 && time < 60) {
      setIsShown("second");
    } else if (minutes > 0) {
      setIsShown("minutes");
    } else if (minutes > 10 && minutes < 60) {
      setIsShown("tminutes");
    }
  }, [props.duration]);

  return (
    <div onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
      {props.duration <= 60 && (
        <>
          {!divShow && (
            <div className="video-preview">
              <div className="videoDuration">
                <div className="wrapper" data-unit={props.duration}>
                  {isShown === "milisecond" && (
                    <span className="videoDurationClass">
                      00:0{props.duration}
                    </span>
                  )}
                  {isShown === "second" && (
                    <span className="videoDurationClass">
                      00:{props.duration}
                    </span>
                  )}
                  {isShown === "minutes" && (
                    <span className="videoDurationClass">
                      0{minutes}:{seconds}
                    </span>
                  )}
                  {isShown === "tminutes" && (
                    <span className="videoDurationClass">
                      {minutes}:{seconds}
                    </span>
                  )}
                </div>
              </div>
              <img
                src={props.url}
                onClick={storeVideoUrl}
                alt="man"
                className="templateImage"
              />
            </div>
          )}

          {divShow && (
            <div className="video-preview" style={{ height: requireHeight }}>
              {/* marginBottom: "-3px", */}
              {Loader && (
                <div className="videoLoader">
                  <div className="spinner-grow" role="status">
                    <span className="sr-only">Loading...</span>
                  </div>
                </div>
              )}
              <video
                className="videoStyle"
                onClick={storeVideoUrl}
                onLoadedData={() => {
                  setLoader(false);
                }}
                onMouseOver={(e) => e.target.play()}
                onMouseOut={(e) => e.target.pause()}
                src={props.VideoUrl}
                type="video/mp4"
                muted
              />
            </div>
          )}
        </>
      )}
    </div>
  );
};
export default Video;
